import { getDOLinkStartURL, getOAuthLinkStartURL, getTelegramLinkStartURL } from "./api";

const TELEGRAM_LINK_STATUS_PARAM = "telegram_link";
const AUTH_FLOW_COMPLETE_PARAM = "auth_complete";
const AUTH_FLOW_COMPLETE_VALUE = "complete";
const AUTH_FLOW_COMPLETE_STORAGE_KEY = "chatcode.auth-flow-complete";

export function isAuthFlowCompleteLocation(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URL(window.location.href).searchParams;
  return (
    params.get(TELEGRAM_LINK_STATUS_PARAM) === AUTH_FLOW_COMPLETE_VALUE ||
    params.get(AUTH_FLOW_COMPLETE_PARAM) === AUTH_FLOW_COMPLETE_VALUE
  );
}

export function getTelegramBotURL(): string | null {
  const username = resolveTelegramBotUsername();
  if (!username) return null;
  return `tg://resolve?domain=${encodeURIComponent(username)}`;
}

export function getTelegramBotStartURL(): string | null {
  const username = resolveTelegramBotUsername();
  if (!username) return null;
  return `tg://resolve?domain=${encodeURIComponent(username)}&start=`;
}

export function openTelegramLinkFlow(): void {
  if (typeof window === "undefined") return;
  const redirectUrl = buildAuthFlowCompletionURL();
  const url = getTelegramLinkStartURL(redirectUrl);
  openAuthWindow(url);
}

export function openOAuthLinkFlow(provider: "google" | "github"): void {
  if (typeof window === "undefined") return;
  const redirectUrl = buildAuthFlowCompletionURL();
  const url = getOAuthLinkStartURL(provider, redirectUrl);
  openAuthWindow(url);
}

export function openDOLinkFlow(): void {
  if (typeof window === "undefined") return;
  const redirectUrl = buildAuthFlowCompletionURL();
  const url = getDOLinkStartURL(redirectUrl);
  openAuthWindow(url);
}

export function notifyAuthFlowComplete(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(
      AUTH_FLOW_COMPLETE_STORAGE_KEY,
      String(Date.now()),
    );
  } catch {
    // Ignore storage failures.
  }
}

export function subscribeAuthFlowComplete(
  listener: () => void,
): () => void {
  if (typeof window === "undefined") return () => {};

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== AUTH_FLOW_COMPLETE_STORAGE_KEY) return;
    try {
      window.localStorage.removeItem(AUTH_FLOW_COMPLETE_STORAGE_KEY);
    } catch {
      // Ignore storage failures.
    }
    listener();
  };

  window.addEventListener("storage", handleStorage);
  return () => window.removeEventListener("storage", handleStorage);
}

function openAuthWindow(url: string): void {
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.target = "_blank";
  anchor.rel = "noopener noreferrer";
  anchor.click();
}

function buildAuthFlowCompletionURL(): string {
  const url = new URL(window.location.origin);
  url.pathname = "/";
  url.searchParams.set(AUTH_FLOW_COMPLETE_PARAM, AUTH_FLOW_COMPLETE_VALUE);
  return url.toString();
}

function resolveTelegramBotUsername(): string | null {
  const explicit = (import.meta.env.VITE_TELEGRAM_BOT_USERNAME ?? "").trim().replace(/^@/, "");
  if (explicit) return explicit;
  return null;
}
